export const routeName = '';
export const slugs: Record<string, string> = {};
export const sitemap = { changefreq: 'weekly', priority: '1.0', lastmod: '2025-01-01' };
